import request from '@/utils/request'

/**
 * 岗位列表
 */
export const getPostList = (data) => {
    return request({
        url: '/post/lists',
        params: data
    })
}

/**
 * 岗位选项列表
 */
export const getPostOptions = () => {
    return request({
        url: '/post/option/lists'
    })
}

/**
 * 新增岗位
 */
export const addPost = (data) => {
    return request({
        url: '/post/manage',
        method: 'POST',
        data
    })
}

/**
 * 岗位-详情
 */
export const getPostDetail = (id) => {
    return request({
        url: `/post/${id}`
    })
}

/**
 * 岗位-编辑
 */
export const putPost = (data) => {
    return request({
        url: '/post/manage',
        method: 'PUT',
        data
    })
}

/**
 * 岗位-删除
 */
export const delPost = (id) => {
    return request({
        url: `/post/${id}`,
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/post/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/post/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/post/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
